import {matchSorter} from "match-sorter";

export function fuzzyTextFilterFn(rows, id, filterValue) {
    return matchSorter(rows, filterValue, {keys: [(row) => row.values[id]]});
}

// Let the table remove the filter if the string is empty
fuzzyTextFilterFn.autoRemove = (val) => !val;

// Define a custom filter function!
export function filterGreaterThan(rows, id, filterValue) {
    return rows.filter((row) => {
        const rowValue = row.values[id];
        return rowValue >= filterValue;
    });
}

// This is an autoRemove method on the filter function that
// when given the new filter value and returns true, the filter
// will be automatically removed. Normally this is just an undefined
// check, but here, we want to remove the filter if it's not a number

filterGreaterThan.autoRemove = (val) => typeof val !== "number";

export function dateRangeFilterFn (rows, id, filterValue) {
    if (!filterValue || !filterValue.range) {
        return rows;
    }

    return rows.filter((row) => {
        const rowValue = row.values[id];
        if (!rowValue) return false;

        const rowDate = new Date(rowValue);

        let startCondition = true;
        let endCondition = true;

        if (filterValue.range[0]) {
            const startDate = new Date(filterValue.range[0]);
            startDate.setHours(0, 0, 0, 0);
            startCondition = rowDate >= startDate;
        }

        if (filterValue.endDate) {
            const endDate = new Date(filterValue.endDate);
            endDate.setHours(23, 59, 59, 999);
            endCondition = rowDate <= endDate;
        }

        return startCondition && endCondition;
    });
}